var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDiscover = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74976 10.7778H44.9998V38.0001H3.76112L3.74976 10.7778Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7014 25.5609C44.7014 25.5609 33.3064 33.9342 12.4385 37.6896H44.7014V25.5609Z",
    fill: "#F48120"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.845 10.0111H3V38H45V10H44.845V10.0111ZM44.7014 10.3223C44.7014 10.6334 44.7014 37.3666 44.7014 37.6777C44.4028 37.6777 3.60785 37.6777 3.30926 37.6777C3.30926 37.3666 3.30926 10.6334 3.30926 10.3223C3.60785 10.3223 44.3921 10.3223 44.7014 10.3223Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66929 18.5691H4.93433V24.9044H6.66929C7.5864 24.9044 8.25003 24.6745 8.83573 24.1787C9.53218 23.5794 9.94069 22.681 9.94069 21.7483C9.93003 19.871 8.59292 18.5691 6.66929 18.5691ZM8.06218 23.3375C7.68647 23.6828 7.21151 23.8444 6.43714 23.8444H6.11722V19.6522H6.43796C7.20085 19.6522 7.66515 19.7907 8.063 20.1591C8.47233 20.5395 8.71515 21.1268 8.71515 21.7372C8.71433 22.3476 8.47069 22.9579 8.06218 23.3375Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6658 18.5691H10.4829V24.9044H11.6658V18.5691Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5606 20.9994C13.8535 20.7233 13.6435 20.5387 13.6435 20.2044C13.6435 19.8009 14.0192 19.5017 14.5278 19.5017C14.8813 19.5017 15.1799 19.6513 15.4785 20.0198L16.0978 19.1786C15.5892 18.7178 14.9814 18.4759 14.3071 18.4759C13.2349 18.4759 12.4064 19.2589 12.4064 20.2959C12.4064 21.1713 12.7936 21.6201 13.8986 22.0355C14.3629 22.2082 14.595 22.3236 14.7164 22.3928C14.9486 22.5544 15.07 22.7844 15.07 23.0494C15.07 23.5674 14.6828 23.9478 14.1529 23.9478C13.5893 23.9478 13.1357 23.6486 12.8601 23.1067L12.0972 23.8786C12.6386 24.7198 13.3022 25.0882 14.1972 25.0882C15.4244 25.0882 16.2972 24.2359 16.2972 23.0032C16.3185 21.9782 15.9092 21.5175 14.5606 20.9994Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6826 21.7483C16.6826 23.6145 18.0862 25.054 19.8876 25.054C20.3962 25.054 20.8383 24.9506 21.3682 24.6856V23.234C20.8933 23.729 20.4733 23.9248 19.9425 23.9248C18.749 23.9248 17.8975 23.0263 17.8975 21.7363C17.8975 20.5156 18.7703 19.559 19.8868 19.559C20.4503 19.559 20.8818 19.7667 21.3674 20.2728V18.8213C20.8482 18.5452 20.4167 18.4297 19.9081 18.4297C18.1305 18.4306 16.6826 19.9052 16.6826 21.7483Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7863 22.8306L29.1612 18.5691H27.8684L30.4434 25.0652H31.0849L33.7041 18.5691H32.422L30.7863 22.8306Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2456 24.9044H37.6056V23.8333H35.4285V22.1287H37.5285V21.0567H35.4285V19.6522H37.6056V18.5691H34.2456V24.9044Z",
    fill: "#231F20"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3027 20.4464C42.3027 19.2598 41.5177 18.5802 40.1477 18.5802H38.3906V24.9155H39.5735V22.3698H39.7286L41.3643 24.9155H42.8236L40.9114 22.2433C41.8056 22.0475 42.3027 21.4141 42.3027 20.4464ZM39.9156 21.4944H39.5727V19.571H39.9377C40.6785 19.571 41.0763 19.8933 41.0763 20.5156C41.0763 21.149 40.6785 21.4944 39.9156 21.4944Z",
    fill: "#231F20"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0054 25.1344C26.7941 25.1344 28.244 23.6233 28.244 21.7594C28.244 19.8954 26.7941 18.3844 25.0054 18.3844C23.2168 18.3844 21.7668 19.8954 21.7668 21.7594C21.7668 23.6233 23.2168 25.1344 25.0054 25.1344Z",
    fill: "url(#paint0_linear_4251_11771)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M25.0054 25.1344C26.7941 25.1344 28.244 23.6233 28.244 21.7594C28.244 19.8954 26.7941 18.3844 25.0054 18.3844C23.2168 18.3844 21.7668 19.8954 21.7668 21.7594C21.7668 23.6233 23.2168 25.1344 25.0054 25.1344Z",
    fill: "url(#paint1_linear_4251_11771)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.055 18.811C43.055 18.6956 42.9779 18.6384 42.8557 18.6384H42.6785V19.1915H42.8114V18.9726L42.9664 19.1915H43.1214L42.9442 18.9615C43.0107 18.9495 43.055 18.8914 43.055 18.811ZM42.8335 18.8914H42.8114V18.7418H42.8335C42.8999 18.7418 42.9328 18.7649 42.9328 18.811C42.9328 18.8683 42.8999 18.8914 42.8335 18.8914Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8779 18.4306C42.6236 18.4306 42.4136 18.6494 42.4136 18.9145C42.4136 19.1795 42.6236 19.3983 42.8779 19.3983C43.1322 19.3983 43.3422 19.1795 43.3422 18.9145C43.3422 18.6494 43.1322 18.4306 42.8779 18.4306ZM42.8779 19.3179C42.6785 19.3179 42.5022 19.1453 42.5022 18.9145C42.5022 18.6956 42.6679 18.511 42.8779 18.511C43.0772 18.511 43.2429 18.6956 43.2429 18.9145C43.2429 19.1333 43.0772 19.3179 42.8779 19.3179Z",
    fill: "#231F20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4251_11771",
    x1: 26.6607,
    y1: 24.4603,
    x2: 24.2887,
    y2: 20.8965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2502,
    stopColor: "#F79A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5331,
    stopColor: "#F68D20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#F48120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4251_11771",
    x1: 26.3073,
    y1: 24.4112,
    x2: 22.8164,
    y2: 17.8638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3587,
    stopColor: "#E16F27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D4602C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9816,
    stopColor: "#D05B2E"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDiscover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/discover.f1739f0f70099340f3782634a8cc2de5.svg";